import { render, staticRenderFns } from "./Ventaadmin.vue?vue&type=template&id=22ad46ca&"
import script from "./Ventaadmin.vue?vue&type=script&lang=js&"
export * from "./Ventaadmin.vue?vue&type=script&lang=js&"
import style0 from "./Ventaadmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports